import React from 'react';
import styles from './index.module.scss';

import Text from '../Text';

export default function BreadcrumbSeparator() {
  return (
    <Text tone="muted" className={styles.text}>
      /
    </Text>
  );
}
